/**
 * Created by RaoMeng on 2020/8/3
 * Desc: 信息服务列表item
 */

import React, { Component } from 'react'

export default class RechargeRecordItem extends Component {

  constructor () {
    super()

    this.state = {}
  }

  componentDidMount () {

  }

  componentWillUnmount () {

  }

  render () {
    const { rechargeBean } = this.props
    return (
      <div className='recharge-record-item-root'>
        <div style={{ flex: 2, padding: '0 4px' }}>缴费{rechargeBean.money}元
        </div>
        <div style={{ flex: 2, padding: '0 4px' }}>{rechargeBean.yearsMany}</div>
        <div style={{
          flex: 3,
          textAlign: 'right',
          padding: '0 4px',
          fontSize:'10px',
        }}>{rechargeBean.costDate}</div>
        {/*<div style={{
                  flex: 3,
                  textAlign: 'right',
                  padding: '0 4px',
                  fontSize:'10px',
                }}>截止日期：{rechargeBean.costDate}</div>*/}
      </div>
    )
  }
}
